import {Async, Loaded, Loading} from 'Core/models/Async';

export type Plan = {
  name?: string;
  life70Name?: string;
  active?: boolean;
};

export type Family = {
  name?: string;
  familyType?: string;
  products?: Product[];
};

export type FamilyReference = {
  name?: string;
  familyType?: string;
};

export type Product = {
  name?: string;
  family?: FamilyReference;
  productGroup?: string;
  friendlyName?: string;
  active?: boolean;
  stateExclusivity?: {
    name: string;
    abbreviation: string;
  };
  productCode?: string;
  companyCode?: number;
  description?: string;
  plans?: Plan[];
};

export class UnassignedPlanModel {
  public readonly key = 'UnassignedPlanModel';
}

export type PlanModel = Async<Plan[]> | UnassignedPlanModel;

type MatchPlanModelOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (plans: Plan[]) => TReturn;
  Error: () => TReturn;
  Unassigned: (plans: []) => TReturn;
};

export const isLoading = (plans: PlanModel): plans is Loading<Plan[]> => plans.key === 'Loading';

export const isLoaded = (plans: PlanModel): plans is Loaded<Plan[]> => plans.key === 'Loaded';

export const matchPlanModel = <TReturn>(options: MatchPlanModelOptions<TReturn>) => (plan: PlanModel) => {
  switch (plan.key) {
    case 'UnassignedPlanModel':
      return options.Unassigned([]);
    case 'Loaded':
      return options.Loaded(plan.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
  }
};
